module.exports = __webpack_public_path__ + "img/cuff_lenght.90c4af40.png";